"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgAppstore = function SvgAppstore(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.368 10a7.16 7.16 0 0 1-1.637 5.13 6.024 6.024 0 0 1-4.757 2.248 6.813 6.813 0 0 1 1.68-4.94A7.285 7.285 0 0 1 34.369 10Zm5.84 10.916a7.272 7.272 0 0 0-3.463 6.101 7.027 7.027 0 0 0 4.29 6.465 16.107 16.107 0 0 1-2.232 4.545c-1.314 1.966-2.692 3.886-4.88 3.922-1.04.024-1.742-.275-2.473-.587-.763-.325-1.559-.664-2.803-.664-1.32 0-2.15.35-2.952.687-.693.292-1.363.574-2.308.613-2.083.077-3.675-2.098-5.037-4.046-2.723-3.977-4.842-11.209-2-16.13a7.81 7.81 0 0 1 6.573-4.008c1.181-.024 2.315.43 3.308.83.76.305 1.439.578 1.994.578.489 0 1.148-.262 1.916-.567 1.211-.48 2.692-1.068 4.202-.91a7.444 7.444 0 0 1 5.865 3.171Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgAppstore);
var _default = exports["default"] = Memo;